export default "__VITE_ASSET__692214e6__"